module.exports = __webpack_public_path__ + "assets/img/tx202s_4.33fd661e.jpg";